const GET_USER_LICENSES_REQUEST = 'GET_USER_LICENSES_REQUEST'
const GET_USER_LICENSES_SUCCESS = 'GET_USER_LICENSES_SUCCESS'
const GET_USER_LICENSES_FAILURE = 'GET_USER_LICENSES_FAILURE'



export function getUserLicenseRequest() {
    return {
      type: GET_USER_LICENSES_REQUEST,
    }
  }

  export function getUserLicenseSuccess(licenses) {
    return {
      type: GET_USER_LICENSES_SUCCESS,
      licenses
    }
  }

  export function getUserLicenseFailure(error) {
    return {
      type: GET_USER_LICENSES_FAILURE,
      error
    }
  }
  


  const initialState = {
      fetchingLicenses : false,
      licensesError : {},
      userlicenses : []
  }

  export function licenses (state = initialState, action) {
    switch (action.type) {
      case GET_USER_LICENSES_REQUEST :
        return {
          ...state,
          fetchingLicenses: true,
        }
       case GET_USER_LICENSES_FAILURE : 
        return {
            ...state,
            fetchingLicenses : false,
            licensesError : action.error
        }
        case GET_USER_LICENSES_SUCCESS : 
        return {
            ...state,
            fetchingLicenses : false,
            userlicenses : action.licenses
        }
        default :
        return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/modules/license.js